import React from 'react';
import { InputLabel } from 'src/web/components/InputLabel/component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import { OL_COLOUR_NAVY_BABY } from 'src/web/components/Style/colours';
import { Tooltip } from 'src/web/Tooltip/Tooltip';
import { AccountCreationOptionWrapper, StyledTooltipOverlay } from '../styles';
import { StyledCheckbox } from './styles';

export interface AccountCreationOptionProps {
  createAccountValue: boolean;
  skipInvitationValue: boolean;
  createAccountError?: string;
  onCreateAccountValueChange: () => void;
  onSkipInvitationValueChange: () => void;
}

export const AccountCreationOption: React.FC<AccountCreationOptionProps> = ({
  createAccountValue,
  skipInvitationValue,
  createAccountError,
  onCreateAccountValueChange,
  onSkipInvitationValueChange,
}) => {
  return (
    <AccountCreationOptionWrapper>
      <InputLabel htmlFor="create-account">
        Create account{' '}
        <Tooltip
          trigger="click"
          placement="bottom"
          overlay={
            <StyledTooltipOverlay>
              To automatically create an account, you must provide the full
              names of each team member.
            </StyledTooltipOverlay>
          }
        >
          <FontAwesomeIcon
            icon={faQuestionCircle}
            color={OL_COLOUR_NAVY_BABY}
          />
        </Tooltip>
      </InputLabel>
      <StyledCheckbox
        onChange={onCreateAccountValueChange}
        checked={createAccountValue}
        error={createAccountError}
        name="create-account"
        label="Automatically create accounts and email team members their password"
      />
      <InputLabel htmlFor="skip-invitation-email">
        Skip invitation email{' '}
        <Tooltip
          trigger="click"
          placement="bottom"
          overlay={
            <StyledTooltipOverlay>
              You can skip invitation emails if you prefer to send customised
              emails from outside the OpenLearning platform.
            </StyledTooltipOverlay>
          }
        >
          <FontAwesomeIcon
            icon={faQuestionCircle}
            color={OL_COLOUR_NAVY_BABY}
          />
        </Tooltip>
      </InputLabel>
      <StyledCheckbox
        onChange={onSkipInvitationValueChange}
        checked={skipInvitationValue}
        name="skip-invitation-email"
        label="Do not send invitation email to team members"
      />
    </AccountCreationOptionWrapper>
  );
};
